export const ADD_FETCH_ALL_COUNT_ADMINS_REQUEST = "FETCH_ALL_COUNTS_ADMINS_REQUEST";
export const ADD_FETCH_ALL_COUNT_ADMINS_SUCCESS = "FETCH_ALL_COUNTS_ADMINS_SUCCESS";
export const ADD_FETCH_ALL_COUNT_ADMINS_FAILURE = "FETCH_ALL_COUNTS_ADMINS_FAILURE";
export const ADD_FETCH_ALL_COUNT_STAFF_REQUEST = "FETCH_ALL_COUNTS_STAFF_REQUEST";
export const ADD_FETCH_ALL_COUNT_STAFF_SUCCESS = "FETCH_ALL_COUNTS_STAFF_SUCCESS";
export const ADD_FETCH_ALL_COUNT_STAFF_FAILURE = "FETCH_ALL_COUNTS_STAFF_FAILURE";
export const RESET_CURRENT_BLOCK = "RESET_CURRENT_BLOCK";